jQuery(function($){
	$('.co-child-menu-footer .search-params .modify-wrapper .modify-params').on('click', function(e){
		e.preventDefault();
		
		let parentDiv = $(this).closest('.search-params');
		parentDiv.find('.sc-field-editor').toggleClass('expanded');
	});

	$('.co-child-menu-footer .search-params form.scfe-form').on('submit', function(){
		const submitButton = $(this).find('.field.submit button');
		
		submitButton.html('<span class="fas fa-cog fa-spin"></span> Updating...');
	});

	$('.co-report-wrapper .co-child-menu-footer .child-menu-footer-left').on('click', function(){
		$(this).closest('.co-child-menu-footer').toggleClass('expanded');
	});
});